import AdminCrud from "@/components/admin/AdminCrud";

export default function AdminPackages() {
  return (
    <AdminCrud
      title="Tour Packages"
      resource="packages"
      defaultItem={{
        name: "",
        destination: "",
        duration_days: 5,
        duration_nights: 4,
        price_from: 25000,
        banner_url: "",
        overview: "",
        highlights: [],
        itinerary: [],
        vehicle_info: "",
        hotel_info: "",
        inclusions: [],
        exclusions: [],
        faqs: [],
        featured: false,
        order: 1,
      }}
      fields={[
        {
          key: "name",
          label: "Package Name",
          type: "text",
          placeholder: "Enter package name",
        },

        {
          key: "destination",
          label: "Destination",
          type: "text",
          placeholder: "Enter destination",
        },

        {
          key: "duration_days",
          label: "Duration (Days)",
          type: "number",
          placeholder: "5",
        },

        {
          key: "duration_nights",
          label: "Duration (Nights)",
          type: "number",
          placeholder: "4",
        },

        {
          key: "price_from",
          label: "Price From (₹)",
          type: "number",
          placeholder: "25000",
        },

        {
          key: "banner_url",
          label: "Package Image",
          type: "image",
        },

        {
          key: "overview",
          label: "Overview",
          type: "textarea",
          rows: 4,
          placeholder: "Enter package overview...",
        },

        {
          key: "highlights",
          label: "Highlights",
          type: "list",
        },

        {
          key: "vehicle_info",
          label: "Vehicle Information",
          type: "textarea",
          rows: 3,
          placeholder: "Enter vehicle information...",
        },

        {
          key: "hotel_info",
          label: "Hotel Information",
          type: "textarea",
          rows: 3,
          placeholder: "Enter hotel information...",
        },

        {
          key: "inclusions",
          label: "Inclusions",
          type: "list",
        },

        {
          key: "exclusions",
          label: "Exclusions",
          type: "list",
        },

        {
          key: "featured",
          label: "Featured on Homepage",
          type: "switch",
        },

        {
          key: "order",
          label: "Display Order",
          type: "number",
        },
      ]}
    />
  );
}